import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  AfterContentInit,
  TemplateRef,
  Directive,
  ViewChildren,
  ElementRef,
  Output,
  EventEmitter
} from '@angular/core';
import {
  NgClass,
  NgForOf,
  NgIf,
  NgTemplateOutlet
} from '@angular/common';

export interface TabItem {
  label: string;
  key: string;
}

@Directive({
  selector: '[gloTabContent]',
  standalone: true,
})
export class GloTabContentDirective {
  @Input('gloTabContent') tabKey!: string;
  constructor(public template: TemplateRef<any>) { }
}

@Component({
  selector: 'glo-tabs',
  imports: [
    NgForOf,
    NgClass,
    NgIf,
    NgTemplateOutlet,
  ],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class GloTabsComponent implements AfterContentInit {
  @Input() tabs: TabItem[] = [];
  @Input() scrollingMode: boolean = false;
  @Input() activeTab: string = '';

  @Output() activeTabChange = new EventEmitter<string>();
  @ContentChildren(GloTabContentDirective) tabContents!: QueryList<GloTabContentDirective>;
  @ViewChildren('tabContentBlock', { read: ElementRef }) tabBlocks!: QueryList<ElementRef>;
  activeTabKey = this.activeTab || this.tabs[0]?.key;
  activeTemplate: TemplateRef<any> | null = null;

  ngOnInit(): void {
    // this.setActiveTab(this.activeTabKey);
  }

  ngAfterContentInit(): void {

    // fix issue
    if (this.tabContents.length === 0) return;
    this.activeTabKey = this.activeTab || this.tabs[0]?.key
    this.setActiveTab(this.activeTabKey);
    // this.updateActiveTemplate();
  }


  setActiveTab(key: string): void {
    this.activeTabKey = key;
    this.activeTabChange.emit(key);

    if (this.scrollingMode) {
      this.scrollToActiveTemplate();
    }
    else {
      this.updateActiveTemplate();
    }
  }

  private updateActiveTemplate(): void {
    if (this.tabContents.length === 0) {
      return;
    }

    this.activeTemplate =
      this.tabContents.find(tc => tc.tabKey === this.activeTabKey)?.template
      ?? null;
  }

  private scrollToActiveTemplate(): void {
    if (this.tabBlocks && this.tabBlocks.length === 0) {
      return;
    }
    if (Array.isArray(this.tabBlocks)) {
      const block = this.tabBlocks.find((el: ElementRef) =>
        el.nativeElement.getAttribute('data-tab-key') === this.activeTabKey
      );

      if (block) {
        block.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
}
